import type { SupportedSession, TellescopeTanstackDefaultsConfig } from "../types";
import { createContext } from "react";

export const TellescopeSessionContext = createContext<SupportedSession | null | undefined>(undefined);

export const TellescopeTanstackConfigContext = createContext<TellescopeTanstackDefaultsConfig | null | undefined>(
  undefined
);
